<div class="container">
  <div class="row">
    <div class="col-12 card-1 mt-3">
      <!-- Top Bar: Back Button -->
      <div class="card-top-bar">
        <!-- Back Button at Top Left -->
        <button class="btn-back-top" (click)="goBack()">
          <i class="fas fa-arrow-left"></i>
          <span>{{ translate.currentLang === 'en' ? 'Back' : 'পিছনে' }}</span>
        </button>
      </div>
      <div class="col-12">
        <div>
          <div *ngIf="product?.status !== 'Awaiting CDS Approval' || product?.status !== 'Approved'"
            class="equity-header">
            <div class="equity-title-wrapper">
              <h2 class="equity-title">{{ translate.currentLang === 'en' ? 'Margin Trading Signup' : 'মার্জিন ট্রেডিং
                সাইন
                আপ' }}</h2>
            </div>
          </div>
          <!-- Status Info and Button Actions -->
          <div class="status-actions-container">
            <div class="status-actions-row">
              <div class="status-info-top" *ngIf="product?.status">
                <p class="status-description">{{ getStatusDescription(product?.status) }}</p>
                <span class="approval-status-badge" [ngClass]="getStatusClass(product?.status)">
                  {{ getStatusText(product?.status) }}
                </span>
              </div>
              <div class="button-actions-wrapper">
                <ng-container *ngTemplateOutlet="btnTemplate"> </ng-container>
              </div>
            </div>
            <p class="equity-description">
              {{ getProductDescription(product?.status) }}
            </p>
          </div>
          <div class="description">
            <!-- Tabs -->
            <div class="tabs-container">
              <!-- Tab Content -->
              <div class="tabs-content">
                <div class="tabs-header">
                  <button class="tab-button" [class.active]="activeTab === 'resident'"
                    (click)="setActiveTab('resident')">
                    {{ translate.currentLang === 'en' ? 'Individual Account' : 'ব্যক্তিগত অ্যাকাউন্ট' }}
                  </button>
                  <button class="tab-button" [class.active]="activeTab === 'non-resident'"
                    (click)="setActiveTab('non-resident')">
                    {{ translate.currentLang === 'en' ? 'Non-Resident Bangladeshi' : 'অনাবাসী বাংলাদেশী' }}
                  </button>
                </div>
                <!-- Resident Tab Content -->
                <div class="tab-pane" [class.active]="activeTab === 'resident'">
                  <div class="tab-content-header">
                    <h4>{{ translate.currentLang === 'en' ? 'List of Required Documents of Individual/Joint Account' :
                      'ব্যক্তিগত/যৌথ অ্যাকাউন্টের প্রয়োজনীয় নথির তালিকা' }}</h4>
                    <p class="tab-subtitle">{{ translate.currentLang === 'en' ? 'Please ensure all documents are
                      properly attested and up to date' : 'অনুগ্রহ করে নিশ্চিত করুন যে সমস্ত নথি সঠিকভাবে সত্যায়িত এবং
                      আপ টু ডেট' }}</p>
                  </div>
                  <div class="document-list">
                    <div class="document-item">
                      <div class="document-number">1</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Three copies of passport size
                          photographs (1st Applicant)' : 'পাসপোর্ট সাইজের তিন কপি ছবি (১ম আবেদনকারী)' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">2</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Three copies of passport size
                          photographs (2nd Applicant)' : 'পাসপোর্ট সাইজের তিন কপি ছবি (২য় আবেদনকারী)' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">3</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'National ID Card/Passport' :
                          'জাতীয় পরিচয়পত্র/পাসপোর্ট' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">4</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Bank Statement/Cheque Leaf' :
                          'ব্যাংক স্টেটমেন্ট/চেক পাতা' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">5</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Two copies of photographs of
                          nominee (duly attested by A/C holder)' : 'নমিনির দুটি কপি ছবি (অ্যাকাউন্ট ধারক কর্তৃক
                          যথাযথভাবে সত্যায়িত)' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">6</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Three copies of photographs of
                          authorized/POA duly attested by A/C holder (If needed)' : 'অনুমোদিত/পিওএ-এর তিন কপি ছবি
                          অ্যাকাউন্ট ধারক কর্তৃক যথাযথভাবে সত্যায়িত (প্রয়োজনে)' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">7</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'National ID Card/Photo of
                          nominee/authorized/POA. (duly attested by A/C holder)' : 'নমিনি/অনুমোদিত/পিওএ-এর জাতীয়
                          পরিচয়পত্র/ছবি (অ্যাকাউন্ট ধারক কর্তৃক যথাযথভাবে সত্যায়িত)' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">8</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Buy/Sale Order book signed by
                          Client + Pay-in' : 'ক্লায়েন্ট কর্তৃক স্বাক্ষরিত ক্রয়/বিক্রয় অর্ডার বই + পে-ইন' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Non-Resident Tab Content -->
                <div class="tab-pane" [class.active]="activeTab === 'non-resident'">
                  <div class="tab-content-header">
                    <h4>{{ translate.currentLang === 'en' ? 'List of Required Documents Non-Resident Bangladeshi
                      (Individual & Joint Account)' : 'অনাবাসী বাংলাদেশীর প্রয়োজনীয় নথির তালিকা (ব্যক্তিগত ও যৌথ
                      অ্যাকাউন্ট)' }}</h4>
                    <p class="tab-subtitle">{{ translate.currentLang === 'en' ? 'For non-resident Bangladeshis, please
                      provide these documents.' : 'অনাবাসী বাংলাদেশীদের জন্য, অনুগ্রহ করে এই নথিগুলি সরবরাহ করুন।' }}
                    </p>
                  </div>
                  <div class="document-list">
                    <div class="document-item">
                      <div class="document-number">1</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Three copies of passport size
                          photographs of the account holder.' : 'অ্যাকাউন্ট ধারকের পাসপোর্ট সাইজের তিন কপি ছবি।'
                          }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">2</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Photocopy of Passport (with
                          valid visa) of account holder.' : 'অ্যাকাউন্ট ধারকের পাসপোর্টের ফটোকপি (বৈধ ভিসা সহ)।'
                          }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">3</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Copy of Service agreement with
                          the employer/Work permit/Residence Permit/Social Security Card/Business documents.' :
                          'নিয়োগকর্তার সাথে চাকরির চুক্তির কপি/কাজের অনুমতি/বাসস্থানের অনুমতি/সামাজিক নিরাপত্তা
                          কার্ড/ব্যবসায়িক নথি।' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">4</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Foreign Currency (FC) Bank
                          account certificate containing name of the applicant name and bank account number.' : 'বিদেশী
                          মুদ্রা (এফসি) ব্যাংক অ্যাকাউন্ট সার্টিফিকেট যাতে আবেদনকারীর নাম এবং ব্যাংক অ্যাকাউন্ট নম্বর
                          রয়েছে।' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">5</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Two copies passport size
                          photographs of the Nominee(s) in any (Attested by account holder).' : 'নমিনি(দের) পাসপোর্ট
                          সাইজের দুটি কপি ছবি (অ্যাকাউন্ট ধারক কর্তৃক সত্যায়িত)।' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">6</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Three copies passport size
                          photographs of authorized & POA (attested by account holder).' : 'অনুমোদিত ও পিওএ-এর পাসপোর্ট
                          সাইজের তিন কপি ছবি (অ্যাকাউন্ট ধারক কর্তৃক সত্যায়িত)।' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">7</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Three copies passport size
                          photographs of 2nd applicant (attested by account holder at the back).' : '২য় আবেদনকারীর
                          পাসপোর্ট সাইজের তিন কপি ছবি (পিছনে অ্যাকাউন্ট ধারক কর্তৃক সত্যায়িত)।' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">8</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Photocopy of Passport (with
                          valid visa of 2nd applicant).' : 'পাসপোর্টের ফটোকপি (২য় আবেদনকারীর বৈধ ভিসা সহ)।' }}</span>
                      </div>
                    </div>
                    <div class="document-item">
                      <div class="document-number">9</div>
                      <div class="document-content">
                        <span class="document-text">{{ translate.currentLang === 'en' ? 'Agreement of POA on
                          Non-Judicial stamp of Tk-300/- (Duly attested notary public)' : '৩০০/- টাকার নন-জুডিশিয়াল
                          স্ট্যাম্পে পিওএ-এর চুক্তি (যথাযথভাবে সত্যায়িত নোটারি পাবলিক)' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #btnTemplate>
  <div class=" me-4col-12">
    <div class="inline-loader loader" [hidden]="!productStatusInProgress"></div>
    <div class="button-actions">
      <div class="status col-12" [ngSwitch]="product?.status" [hidden]="product?.noSignup">
        <button class="button-d btn-shadow btn btn-fill btn btn-md" (click)="goToProduct()" *ngSwitchDefault>
          <span>{{ translate.currentLang === 'en' ? 'Sign Up Now' : 'এখন সাইন আপ করুন' }}</span>
          <i class="fas fa-arrow-right"></i>
        </button>

        <span class="btn-shadow btn btn-fill btn btn-md status-pending" *ngSwitchCase="'Rejected'">{{
          translate.currentLang === 'en' ? 'Approval Pending' : 'অনুমোদন মুলতুবি' }}</span>

        <button *ngSwitchCase="'Returned'" class="button-d btn-shadow btn btn-fill btn btn-md"
          (click)="changeStatusToModifying(product?.id)">
          <span>{{ translate.currentLang === 'en' ? 'Cancel Submit and Edit' : 'জমা বাতিল করুন এবং সম্পাদনা করুন'
            }}</span>
          <i class="fas fa-arrow-right"></i>
        </button>
        <button *ngSwitchCase="'Submitted'" class="button-d btn-shadow btn btn-fill btn btn-md"
          (click)="changeStatusToModifying(product?.id)">
          <span>{{ translate.currentLang === 'en' ? 'Cancel Submit and Edit' : 'জমা বাতিল করুন এবং সম্পাদনা করুন'
            }}</span>
          <i class="fas fa-arrow-right"></i>
        </button>
        <button *ngSwitchCase="'Re-Submitted'" class="button-d btn-shadow btn btn-fill btn btn-md"
          (click)="changeStatusToModifying(product?.id)">
          <span>{{ translate.currentLang === 'en' ? 'Cancel Submit and Edit' : 'জমা বাতিল করুন এবং সম্পাদনা করুন'
            }}</span>
          <i class="fas fa-arrow-right"></i>
        </button>
        <button *ngSwitchCase="'Approval Pending'" class="button-d btn-shadow btn btn-fill btn btn-md">
          <span>{{ translate.currentLang === 'en' ? 'Approval Pending' : 'অনুমোদন মুলতুবি' }}</span>
        </button>

        <span class="status-approved icon-xl" *ngSwitchCase="'Approved'"> <i
            class="icon-001_check-2 icon-lg"></i></span>
        <button class="button-d btn-shadow btn-fill btn btn-md status-draft" *ngSwitchCase="'Draft'"
          routerLink="/{{ product?.key }}/signup" [queryParams]="{ uid: currentUser?.id }">
          <span>{{ translate.currentLang === 'en' ? 'Continue to Edit' : 'সম্পাদনা চালিয়ে যান' }}</span>
          <i class="fas fa-arrow-right"></i>
        </button>
        <button class="button-d btn-shadow btn-fill btn btn-md status-re-enable" *ngSwitchCase="'Modifying'"
          routerLink="/{{ product?.key }}/signup" [queryParams]="{ uid: currentUser?.id }">
          <span>{{ translate.currentLang === 'en' ? 'Re-Enable to Edit' : 'সম্পাদনার জন্য পুনরায় সক্রিয় করুন'
            }}</span>
          <i class="fas fa-arrow-right"></i>
        </button>
        <span *ngSwitchCase="'loading'">&nbsp;</span>
      </div>
    </div>
  </div>
</ng-template>